import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LinkIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Link",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M23 19.79c0-.97-.78-1.75-1.75-1.75s-1.75.78-1.75 1.75v6.57c0 .08-.07.15-.15.15h-6.7c-.08 0-.15-.07-.15-.15v-6.57c0-.97-.78-1.75-1.75-1.75S9 18.82 9 19.79v6.57c0 2.02 1.63 3.65 3.65 3.65h6.7c2.02 0 3.65-1.63 3.65-3.65zm0-14.14C23 3.63 21.37 2 19.35 2h-6.7C10.63 2 9 3.63 9 5.65v6.57c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75V5.65c0-.08.07-.15.15-.15h6.7c.08 0 .15.07.15.15v6.57c0 .97.78 1.75 1.75 1.75S23 13.19 23 12.22zm-5.25 16.04V10.32c0-.97-.78-1.75-1.75-1.75s-1.75.78-1.75 1.75v11.37c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M10.47 29.5c-1.95 0-3.9-.74-5.38-2.22s-2.23-3.35-2.23-5.38.79-3.94 2.23-5.38l2.29-2.29c.45-.45 1.17-.45 1.62 0s.45 1.17 0 1.62l-2.29 2.29c-1.01 1.01-1.56 2.34-1.56 3.76s.55 2.76 1.56 3.76a5.34 5.34 0 0 0 7.53 0l2.29-2.29c.45-.45 1.17-.45 1.62 0s.45 1.17 0 1.62l-2.29 2.29a7.59 7.59 0 0 1-5.38 2.22ZM24.18 18.47c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l2.29-2.29a5.34 5.34 0 0 0 0-7.53c-2.08-2.08-5.45-2.07-7.53 0l-2.29 2.29c-.45.45-1.17.45-1.62 0s-.45-1.17 0-1.62l2.29-2.29a7.61 7.61 0 0 1 10.76 0 7.61 7.61 0 0 1 0 10.76l-2.29 2.29c-.22.22-.52.33-.81.33Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.75 20.75c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l6.86-6.86c.45-.45 1.17-.45 1.62 0s.45 1.17 0 1.62l-6.86 6.86c-.22.22-.52.33-.81.33"
      })]
    })
  }));
};
LinkIcon.displayName = 'LinkIcon';